import axios from 'axios';

export default (userId, type, amount, description) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .post(process.env.VUE_APP_API_ADMIN_LOCATION + 'users/wallet', {
        user_id: userId,
        amount,
        type,
        description,
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
